import React, { ReactNode } from 'react';
import Text from '../Text/Text';
import moment from 'moment';
import './ScheduleViewer.less';

export type ScheduleViewerProps = {
  children?: ReactNode;
  start?: string;
  end?: string;
  type?: string;
  locale?: string;
  isFlexible?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TScheduleViewer: React.FC<ScheduleViewerProps> = ({
  start,
  end,
  locale,
  type,
  isFlexible,
}) => {
  const classNames = ['t-scheduleViewerContainer'];
  const startDate = moment(start).format('MMM D');
  const endDate = moment(end).format('MMM D');

  function MonthShow() {
    if (start && end) {
      return `${startDate} - ${endDate}`;
    }
    if (start || end) {
      return `${start ? startDate : endDate}`;
    }
    return null;
  }

  moment.locale(locale === 'hy' ? 'hy-am' : locale);

  return (
    <div className={classNames.join(' ')}>
      <Text level={3} rows={1}>
        {MonthShow()}
      </Text>
      <span className="t-scheduleTypeText">{type}</span>
      {!!isFlexible && (
        <Text level={3} rows={1} textColor="dark-50">
          Flexible
        </Text>
      )}
    </div>
  );
};

export default TScheduleViewer;
